import { render, staticRenderFns } from "./FooterAgir360.vue?vue&type=template&id=2fa07d78&scoped=true"
import script from "./FooterAgir360.vue?vue&type=script&lang=js"
export * from "./FooterAgir360.vue?vue&type=script&lang=js"
import style0 from "./FooterAgir360.vue?vue&type=style&index=0&id=2fa07d78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa07d78",
  null
  
)

export default component.exports